module.exports = "/_next/static/images/GeorgiaLogo-d89892e7981b434fbd81996c240c9fc4.png";